import Heading from "../../components/Heading";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import DossDocTable from "../../components/AllTables/DossDocTable";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  Form,
} from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import urls from "../../Utils/urls";
import { SpinnerBlock } from "../../Utils/CustomComponent";

export default function DossDoc() {
  const [copiedMessage, setCopiedMessage] = useState("");
  const [data, setData] = useState(null);
  const [subData, setSubData] = useState([]);
  const [loading, setLoading] = useState(false);

  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Doss Doc Report" />,
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
    {
      component: <DossDocTable />,
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    async function getDisCodeAndLoanqId() {
      try {
        const res = await axios.get(urls.dosssdoc.getDossDocDataNew(userId), {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        });
        if (res?.data?.items) {
          const data = res?.data?.items[0];
          setData(data);
        }
      } catch (error) {
        console.error(error);
      }
    }
    async function getDossDocSubmittedDocData() {
      setLoading(true);
      try {
        const response = await axios.get(
          urls.dosssdoc.getDossDocSubmittedDocData(),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          }
        );
        if (response?.data?.items) {
          const subdata = response?.data?.items;
          setSubData(subdata);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    getDisCodeAndLoanqId();
    getDossDocSubmittedDocData();
  }, [userId]);

  const discountCode = data?.discount_code;
  const loanLinQID = data?.loanlinq_user_id;

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedMessage(`${label} Copied!`);
      clearTimeout(copyToClipboard.timeout);
      copyToClipboard.timeout = setTimeout(() => setCopiedMessage(""), 1000);
    });
  };

  return (
    /*<div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
       <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section> 
    </div>*/

    <div>
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <h4 className="mt-4 mb-3">
            Prepare Your Loan Documents with DossDoc
          </h4>
          <div
            className="p-5"
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              height: "92vh",
            }}
          >
            {/* <h4 className="mb-4 ms-4">
              Prepare Your Loan Documents with DossDoc
            </h4> */}
            <p className="mb-4">
              We’ve partnered with DossDoc to help you prepare and submit loan
              documents easily. Use the discount code below on{" "}
              <a
                href="https://dossdoc.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                dossdoc.com
              </a>{" "}
              for reduced document fees.
            </p>

            <Row className="my-4 gx-5">
              <Col md={6} className="px-5">
                <Card className="p-5 text-center shadow-sm rounded-4">
                  <h5>Discount Code</h5>
                  <div className="m-5 p-5 border border-primary text-primary">
                    {data?.discount_code}
                  </div>
                  <div className="d-grid gap-2">
                    <Button
                      variant="primary"
                      href="https://dossdoc.com"
                      target="_blank"
                      className="m-5 p-5"
                    >
                      Go to DossDocSite
                    </Button>
                    <Button
                      variant="outline-primary"
                      className="m-5"
                      onClick={() =>
                        copyToClipboard(discountCode, "Discount Code")
                      }
                    >
                      Copy Code
                    </Button>
                    {copiedMessage === "Discount Code Copied!" && (
                      <div className="text-success mt-2 fw-semibold">
                        ✅ {copiedMessage}
                      </div>
                    )}
                  </div>
                </Card>
              </Col>

              <Col md={6} className="px-5">
                <Card className="p-5 text-center shadow-sm rounded-4">
                  <h5 className="mb-3 p-2">Your LoanLinQ ID</h5>
                  <div className="m-5 p-5 border border-primary text-primary">
                    {data?.loanlinq_user_id}
                  </div>
                  <div className="d-grid gap-2">
                    <Button
                      variant="outline-primary"
                      className="m-5"
                      onClick={() => copyToClipboard(loanLinQID, "LoanLinQ ID")}
                    >
                      Copy Code
                    </Button>
                    {copiedMessage === "LoanLinQ ID Copied!" && (
                      <div className="text-success mt-2 fw-semibold">
                        ✅ {copiedMessage}
                      </div>
                    )}
                  </div>
                  <div className="text-muted mt-5 mb-3">
                    Use this code in “LoanLinQ ID” field on DossDoc
                  </div>
                </Card>
              </Col>
            </Row>

            <h5 className="mt-5 mb-4">What Happens Next</h5>
            <p className="mb-4">
              Once you submit your loan documents on DossDoc, we’ll receive them
              and notify you here when they're linked to your loan.
            </p>

            <h5 className="mt-5 mb-4">Submitted Documents</h5>
            <div style={{ height: "35vh", overflowY: "auto" }}>
              <Table bordered className="mb-4">
                <thead
                  className="text-white"
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "var(--primary-color)",
                    zIndex: 1,
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  <tr>
                    <th>Date</th>
                    <th>Loan</th>
                    <th>Status</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading ? (
                    subData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.submission_date}</td>
                        <td>{item.loan}</td>
                        <td>{item.status || "Pending"}</td>
                        <td>
                          <Button variant="outline-primary" size="sm" disabled>
                            Download
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="text-center">
                      <td colSpan={4}>
                        <SpinnerBlock height="10vh" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
